import cn from 'classnames'
import { FunctionComponent } from 'react'
import { Navigation } from '../Navigation'
import { NavigationContacts } from '../NavigationContacts'
import styles from './MobileMenu.module.scss'

type MobileMenuProps = {
  className?: string
  closeMenu?: () => void
  telegram: string
  whatsapp: string
  max: string
}

export const MobileMenu: FunctionComponent<MobileMenuProps> = ({
  className,
  closeMenu,
  telegram,
  whatsapp,
  max,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.content}>
        <Navigation
          className={styles.navigation}
          linkClick={closeMenu}
          telegram={telegram}
          whatsapp={whatsapp}
          max={max}
        />
      </div>
      <NavigationContacts
        className={styles.contacts}
        whatsapp={whatsapp}
        telegram={telegram}
        max={max}
      />
    </div>
  )
}
